import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { CommonHash } from 'app/types';
import Text from 'common/components/Text/Text';

import styles from '../LandingForm.module.scss';
import LandingComponentButtonForm from '../LandingComponentButtonForm';
import SubLandingComponentForm from '../SubLandingComponentForm';
import { LANDING_CARD_STYLES } from 'common/constants';

interface ComponentFormProps {
  landing_cmp: CommonHash;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  index: number;
}

const numberOfCardsOptions = ['1', '1-2', '2', '2-2', '3', '4', '5', '6'];

const CardGridForm = ({
  landing_cmp,
  handleChange,
  index,
}: ComponentFormProps): React.ReactElement => {
  const cardStyleOptions = LANDING_CARD_STYLES.map(([label, value]) => ({
    label: label,
    value: value,
  }));
  const [cardStyle, setCardStyle] = useState<CommonHash>({
    label:
      cardStyleOptions.find((option) => option.value === landing_cmp.config.card_style)?.label ||
      'Simple',
    value: landing_cmp.config.card_style || 'simple',
  });

  useEffect(() => {
    handleChange({
      target: {
        name: `landing_components[${index}].config['card_style']`,
        value: cardStyle.value,
      },
    });
  }, [cardStyle]);
  return (
    <>
      <div className={`form-group`}>
        <label htmlFor={`landing_components[${index}].config['display_overflow']`}>
          Overflow display
        </label>
        <select
          className="form-select"
          name={`landing_components[${index}].config['display_overflow']`}
          onChange={handleChange}
          value={landing_cmp.config ? landing_cmp.config['display_overflow'] : 'downwards'}
        >
          <option value="downwards">Downwards</option>
          <option value="carousel">Carousel</option>
        </select>
      </div>
      <div className={`form-group`}>
        <label htmlFor={`landing_components[${index}].config['columns_lg']`}>
          Number of Columns at Desktop
        </label>
        <select
          name={`landing_components[${index}].config['columns_lg']`}
          className="form-control"
          // placeholder="Number of card per row for desktop"
          required={true}
          value={landing_cmp.config['columns_lg'] || '4'}
          onChange={handleChange}
        >
          {numberOfCardsOptions.map((opt, e) => {
            return (
              <option key={e} value={opt}>
                {opt}
              </option>
            );
          })}
        </select>
      </div>
      <div className={`form-group`}>
        <label htmlFor={`landing_components[${index}].config['columns_md']`}>
          Number of Columns at Tablet
        </label>
        <select
          name={`landing_components[${index}].config['columns_md']`}
          className="form-control"
          // placeholder="Number of card per row for tablet"
          required={true}
          value={landing_cmp.config['columns_md'] || '2'}
          onChange={handleChange}
        >
          {numberOfCardsOptions.map((opt, e) => {
            return (
              <option key={e} value={opt}>
                {opt}
              </option>
            );
          })}
        </select>
      </div>
      <div className={`form-group`}>
        <label htmlFor={`landing_components[${index}].config['columns_sm']`}>
          Number of Columns at Mobile
        </label>
        <select
          name={`landing_components[${index}].config['columns_sm']`}
          className="form-control"
          // placeholder="Number of card per row for desktop"
          required={true}
          value={landing_cmp.config['columns_sm'] || '2-2'}
          onChange={handleChange}
        >
          {numberOfCardsOptions.map((opt, e) => {
            return (
              <option key={e} value={opt}>
                {opt}
              </option>
            );
          })}
        </select>
      </div>
      <div className={`form-group`}>
        <label htmlFor={`landing_components[${index}].config['card_style']`}>
          Card visualization style
        </label>
        <div className={styles.selectorAttribute}>
          <Select
            isSearchable
            classNamePrefix="react-select"
            className={styles.filtersFormSelect}
            placeholder="Select Background"
            options={cardStyleOptions}
            onChange={(cardStyle: any) => {
              setCardStyle(cardStyle);
            }}
            value={cardStyle}
          />
        </div>
      </div>
      <Text size={22} weight={600} inlineStyle={{ marginTop: '20px', marginBottom: '10px' }}>
        {cardStyle.label} Cards
      </Text>
      <SubLandingComponentForm
        name={`landing_components[${index}].sub_landing_components`}
        landing_component={landing_cmp}
        handleChange={handleChange}
        limit={50}
        sub_component={cardStyle.value}
        component_name={'Card'}
      />

      <Text size={22} weight={600} inlineStyle={{ marginTop: '20px', marginBottom: '10px' }}>
        Cards section buttons
      </Text>
      <LandingComponentButtonForm
        name={`landing_components[${index}].landing_component_buttons`}
        landing_component={landing_cmp}
        handleChange={handleChange}
        limit={5}
      />
    </>
  );
};

export default CardGridForm;
